export const SERVICE_POINT_DELIVERY = 'service_point'
export const ADDRESS_DELIVERY = 'address'
